// src/contexts/settingsContext.js  
import React, { createContext, useReducer, useContext } from 'react';
import { settingsReducer, initialState } from '../reducers/settingsReducer';

const SettingsContext = createContext();

export const SettingsProvider = ({ children }) => {
    const [state, dispatch] = useReducer(settingsReducer, initialState);
    return (
        <SettingsContext.Provider value={{ state, dispatch }}>
            {children}
        </SettingsContext.Provider>
    );
};

export const useSettings = () => useContext(SettingsContext);  
